export default "__VITE_ASSET__D_9jbKC4__"